import React, { useContext } from "react";
import { DiamondSearchContext } from "../../../../utils/stateHandlers/contexts.jsx";
import Shape from "../../shapes/Shape.jsx";
import Typography from "@mui/material/Typography";
import _ from "lodash";

export default function ShapeFilter(props) {
  const { diamondState, dispatch } = useContext(DiamondSearchContext);
  const { filters, searchQuery } = diamondState;
  const shapeFilter = _.find(filters, function (filter) {
    return filter.name === "Shape";
  });

  function isActive(shapeName) {
    const selectedValue = _.find(searchQuery.fields, function (field) {
      return field.name === "Shape";
    });
    if (selectedValue) {
      const bool = _.find(selectedValue.values, function (value) {
        return value.name === shapeName ? true : false;
      });
      return bool;
    }
  }

  function selectShape(shapeName) {
    const searchField = _.find(searchQuery.fields, function (field) {
      return field.name === "Shape";
    });
    if (searchField) {
      const shapeFound = _.find(searchField.values, function (value) {
        return value.name === shapeName;
      });
      if (shapeFound) {
        const removeSelected = _.remove(searchField.values, function (value) {
          return value.name !== shapeName;
        });
        searchField.values = removeSelected;
        dispatch({ type: "updateSearchQuery", payload: searchQuery.fields });
      } else {
        const newSelectedShapes = _.concat(searchField.values, {
          name: shapeName,
        });
        searchField.values = newSelectedShapes;
        dispatch({ type: "updateSearchQuery", payload: searchQuery.fields });
      }
    } else {
      const newSearchFields = _.concat(searchQuery.fields, {
        name: "Shape",
        values: [
          {
            name: shapeName,
          },
        ],
      });
      dispatch({ type: "updateSearchQuery", payload: newSearchFields });
    }
  }

  return (
    <div className="filter filter--shape">
      {shapeFilter.values.map((value) => (
        <div
          key={value.name}
          onClick={() => selectShape(value.name)}
          className="shape-value"
        >
          <div className="shape-icon cursor-pointer">
            <Shape
              type={value.name}
              color={isActive(value.name) ? "black" : "#4280aa"}
              stroke_width={isActive(value.name) ? "1%" : "0.4%"}
              width="40"
            />
          </div>
          <Typography
            variant="body3"
            className={[
              "cursor-pointer",
              "shape-label " +
                (isActive(value.name) ? "shape-label--selected" : ""),
            ].join(" ")}
          >
            {value.name}
          </Typography>
        </div>
      ))}
    </div>
  );
}
